<template>
  <div>
    <h5 class="mb-3">
      {{ dataComponent.name }}
    </h5>

    <div class="wrap-hierarchy">
      <img
        v-if="isCustom"
        src="@/assets/app-manager/img/dummy-custom-hierarchy.svg"
        alt="dummy-custom-hierarchy"
      >
      <img
        v-else
        src="@/assets/app-manager/img/dummy-hierarchy.svg"
        alt="dummy-custom-hierarchy"
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
    isCustom: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-hierarchy {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
  padding-bottom: 20px;

  img {
    width: 120%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyHierarchy.vue